import React from "react";
import "@fyendalscollection/marketing/styles/base.scss";
import ReactDOM from "react-dom/client";
import { Router } from "@fyendalscollection/marketing/Router";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@fyendalscollection/marketing/lib/ThemeContext";

export const Main = (): JSX.Element => (
	<React.StrictMode>
		<BrowserRouter>
			<ThemeProvider>
				<Router />
			</ThemeProvider>
		</BrowserRouter>
	</React.StrictMode>
);

ReactDOM.createRoot(document.getElementById("root")!).render(<Main />);
